import React, { useEffect } from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import { useLocation, useNavigate,  useSearchParams } from "react-router-dom";
import Navbar from "react-bootstrap/Navbar";
import "../home/index.css";
import { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Footer } from "../Components/footer";
import axios from "axios";
import { LoadingSpinner } from "../Components/loading";
import ShareButtons from "../Components/share";
import { EncodeStringToAscii } from "../Components/datahide";
import CountUp from "react-countup";
import { ZoomInElement } from "../Components/animations";
import { BASE_URL as api } from "../services";
import { toast } from "react-toastify";

export const LandingPage = () => {
  const location = useLocation();
  const history = useNavigate();
  const queryParams = new URLSearchParams(location.search);

  const pageValue = queryParams.get("page");
  const [email, setEmail] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showlogin, setShowlogin] = useState(!!pageValue);
  const [isLoading, setIsLoading] = useState(false);
  const [count, setCount] = useState("");
  const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const showPassword = () => {
    var x = document.getElementById("showpassword");
    if (x.type === "password") {
      x.type = "text";
    } else {
      x.type = "password";
    }
  };
  const Login = async () => {
    setIsLoading(true);
    try {
      const result = await axios.post(api + "/login", {
        email,
        password,
      });
      if (result.data) {
        if (result.data === "no") {
          toast.error(
            "You dont have an account  please sign up / verify your password and try again"
          );
          // window.location.href = "/signup";
        } else {
          sessionStorage.setItem("token", result.data.Email);
          toast.success("Successfully logged in");
          const login = await axios.post(api + "/userlink", {
            email,
          });
          if (login.data !== "null-999") {
            sessionStorage.setItem("username", login.data);



            if (window.opener) {
                window.opener?.postMessage({ userData:login.data }, queryParams.get("from"));
              window.close()                
            }


            window.location.href = "/";
          } else {
            window.location.href = "/";
          }
        }
      }
    } catch (e) {
      console.log(e)
      toast.error(e.message);
    } finally {
      history("/", { replace: true });
      setIsLoading(false);
    }
  };

  const getCount = async () => {
    try {
      const result = await axios.post(api + "/count");
      if (result.data) {
        setCount(result.data);
      }
    } catch (error) {
      console.error("Error fetching count:", error);
      // Handle error if needed
    }
  };

  useEffect(() => {
    // Initial call
    getCount();

    // Set up interval to call getCount every 60 seconds
    const intervalId = setInterval(() => {
      getCount();
    }, 60000);

    return () => clearInterval(intervalId);
  }, []);
  const handleFindUser = () => {
    const usernameRegex = /^[a-zA-Z0-9_]{3,50}$/;

    if (usernameRegex.test(username)) {
      // Navigate to the user's location
      history(`/${username.toLowerCase()}`);
    } else {
      toast.error("Invalid username. Please enter a valid username.");
    }
  };

  return (
    <>
      <LoadingSpinner state={isLoading} />
      {/* login model */}
      <Modal
        show={showlogin}
        onHide={() => {
          setShowlogin(false);
          window.location.href = "/";
        }}
        dialogClassName="modal-90w"
        aria-labelledby="example-custom-modal-styling-title"
      >
        <LoadingSpinner state={isLoading} />
        <Modal.Header closeButton className="bg-dark">
          <Modal.Title
            id="example-custom-modal-styling-title"
            className="text-light"
          >
            Login
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-dark text-light">
          <div className="form">
            <div className="text-center">
              <img
                className="mb-4 text-center"
                src="./myport.png"
                alt=""
                width={82}
                height={82}
                style={{
                  boxShadow: "rgba(250, 250, 252, 0.2) 0px 7px 29px 0px",
                  borderRadius: "20px",
                }}
              />
            </div>
            {/* <h1 className="h3 mb-3 fw-normal text-center">Please login</h1> */}
            <div className="form-floating ">
              <input
                type="email"
                className="form-control"
                id="floatingInput"
                placeholder="name@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <label htmlFor="floatingInput" className="text-dark">
                Email address
              </label>
            </div>
            <br />
            <div className="form-floating">
              <input
                type="password"
                className="form-control"
                id="showpassword"
                value={password}
                placeholder="Password"
                onChange={(e) => setPassword(e.target.value)}
              />
              <label htmlFor="floatingPassword" className="text-dark">
                Password
              </label>
            </div>
            <div className="form-check text-start my-3">
              <input
                className="form-check-input"
                type="checkbox"
                onClick={showPassword}
              />
              <label className="form-check-label" htmlFor="flexCheckDefault">
                Show Password
              </label>
            </div>
            <div className="d-flex justify-content-between">
              <button
                className="btn btn-danger py-2"
                type="button"
                disabled={!emailRegex.test(email)}
                onClick={() => {
                  const encod = EncodeStringToAscii(email);
                  window.location.href = `/forgot?id=${encod}`;
                }}
              >
                Forgot Password
              </button>
              <button
                className="btn btn-primary w-25 py-2"
                type="submit"
                onClick={Login}
              >
                Login{" "}
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      {/* login model end */}
      <div className="langingpage">
        <Navbar
          expand="lg"
          className="navbar navbar-expand-sm bg-dark navbar-dark"
        >
          <Container>
            <Navbar.Brand href="/">
              <img
                alt=""
                src="./myport.png"
                width="40"
                height="40"
                className="d-inline-block "
              />{" "}
              <i className="fa-solid ">My Portfolio</i>
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="me-auto">
                <Nav.Link href="/create" className="text-light">
                  {sessionStorage.token && !sessionStorage.username && (
                    <a href="/create">
                      <i className="fa-solid fa-plus"> Create My Portfolio</i>
                    </a>
                  )}
                </Nav.Link>
              </Nav>
              <Nav>
                {!sessionStorage.token && (
                  <Nav.Link href="/signup" className="text-light">
                    <i className="fa-solid fa-user-plus"> Sign Up</i>
                  </Nav.Link>
                )}
                {sessionStorage.token && sessionStorage.username && (
                  <h3 className="text-white  me-5">
                    WELCOME {sessionStorage.username.toUpperCase()}!
                  </h3>
                )}
                {sessionStorage.token ? (
                  <Nav.Link
                    className="text-light"
                    onClick={() => {
                      setIsLoading(true);
                      try {
                        
                       
                        toast.success("Logged out Successfully");

                        
                        sessionStorage.clear();

                       
                        setTimeout(() => {
                          window.location.reload();
                        }, 1000);
                      } finally {
                        setIsLoading(false);
                      }
                    }}
                  >
                    <i className="fa-solid fa-right-to-bracket"> logout</i>
                  </Nav.Link>
                ) : (
                  <Nav.Link
                    className="text-light"
                    onClick={() => setShowlogin(true)}
                  >
                    <i className="fa-solid fa-right-to-bracket"> Login</i>
                  </Nav.Link>
                )}
                {/* {
                sessionStorage.token && sessionStorage.username && (
                 <h3 className="rounded-circle text-success text-bold ms-5 bg-light p-2 d-none d-sm-block">
                  {sessionStorage.username.substring(0, 1).toUpperCase()}
                  </h3>
                 )
                } */}
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>

        <section>
          <div className="px-4   py-2  text-center logo-moto">
            <ZoomInElement>
              <img
                className="d-block mx-auto mb-4 logo-landing"
                src="./myport.png"
                alt=""
                width={150}
                height={150}
              />{" "}
            </ZoomInElement>
            <h1 className="display-6 fw-bold text-light ">
              <>My Portfolio</>
            </h1>
            <div className="col-lg-7 mx-auto">
              <p className="lead mb-4  text-light text-my">
                Build your standout portfolio effortlessly! Our user-friendly
                platform lets you create and showcase your achievements in
                minutes. Enjoy a seamless experience, all in one place. Craft
                your professional online presence quickly and easily!
              </p>
              <div className="d-grid gap-2 d-sm-flex justify-content-sm-center">
                {sessionStorage.token && !sessionStorage.username && (
                  <a href="/create">
                    <button
                      type="button"
                      className="btn btn-primary btn-lg px-4 gap-3 text-my"
                    >
                      Create
                    </button>
                  </a>
                )}
                {sessionStorage.token && sessionStorage.username && (
                  <a href={`/${sessionStorage.username}`}>
                    <button
                      type="button"
                      className="btn btn-success btn-lg px-4 gap-3 text-my"
                    >
                      View My Portfolio
                    </button>
                  </a>
                )}
                {sessionStorage.token && sessionStorage.username && (
                  <a href={`/update`}>
                    <button
                      type="button"
                      className="btn btn-success btn-lg px-4 gap-3 text-my"
                    >
                      Update My Portfolio
                    </button>
                  </a>
                )}
                {!sessionStorage.token && (
                  <a href="/signup">
                    <button
                      type="button"
                      className="btn btn-primary btn-lg px-4 text-my "
                    >
                      Signup to Create
                    </button>
                  </a>
                )}
                {!sessionStorage.token && (
                  <a href="/?page=true">
                    <button
                      type="button"
                      className="btn btn-primary btn-lg px-4 text-my "
                    >
                      Have an account login !
                    </button>
                  </a>
                )}
              </div>
              <div className="d-grid gap-2 d-sm-flex justify-content-sm-center mt-5">
                {sessionStorage.token && sessionStorage.username && (
                  <div className="border border-dark box-shadow rounded">
                    <h2 className="text-light text-my">
                      Share Your Portfolio on{" "}
                    </h2>
                    <ShareButtons
                      url={`https://portfolionom.vercel.app/${sessionStorage.username}`}
                      title={`
          This portfolio showcases my work, crafted effortlessly through the MyPortfolio web app. 
          Design your unique web portfolio seamlessly, without any coding. 
          Explore the intuitive process at https://portfolionom.vercel.app. 
          Experience the simplicity of creating your personalized portfolio with zero coding expertise.
        `}
                    />
                  </div>
                )}

                {!sessionStorage.token && !sessionStorage.username && (
                  <div className="border border-light bg-light box-shadow rounded m-1">
                    <h2 className="text-dark text-my">My Portfolio Users</h2>
                    <div className="row ps-3 pe-3">
                      <div className="col-12 col-lg-6 mb-4">
                        <div className="bg-my text-light rounded border-dark p-3">
                          Registered Users
                          <br />
                          {count && count.count1 && (
                            <h1 className="display-3 ">
                              <CountUp end={count.count1} enableScrollSpy />
                            </h1>
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-lg-6 mb-4">
                        <div className="bg-my text-light rounded border-dark p-3">
                          Portfolios Created
                          <br />
                          {count && count.count2 && (
                            <h1 className="display-6">
                              <CountUp end={count.count2} enableScrollSpy />
                            </h1>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>

        <section>
          <div className="container d-flex align-items-center justify-content-center mt-3">
            <div className="" style={{ width: "350px", height: "70px" }}>
              <div className="">
                <div className="input-group bg-dark">
                  <input
                    type="text"
                    className="form-control "
                    placeholder="Enter username"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                  />
                  <div className="input-group-append">
                    <button
                      className="btn btn-primary btn-sm"
                      type="button"
                      onClick={handleFindUser}
                    >
                      Find Portfolio
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </section>
      </div>
    </>
  );
};
